export default function TikTokIcon({ size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.4 18.2c-3.4 0-6.5-1.1-9.1-3v13.3c0 6.7-5.4 12.1-12.1 12.1S5.1 35.2 5.1 28.5 10.5 16.4 17.2 16.4c0.6 0 1.1 0 1.7 0.1v6.7c-0.5-0.2-1.1-0.3-1.7-0.3-3 0-5.5 2.5-5.5 5.5s2.5 5.5 5.5 5.5 5.5-2.5 5.5-5.5V4h6.5c0 0.6 0.1 1.1 0.2 1.7 0.7 3.6 3.6 6.5 7.2 7.1 0.6 0.1 1.1 0.1 1.7 0.1v5.3z"
        fill="white"
      />
    </svg>
  );
}
